/**
 * Publishes the current selection's size to a store so the status bar can
 * show "N words selected" while a selection exists.
 */
import { EditorView } from "@codemirror/view";
import type { Extension } from "@codemirror/state";
import { create } from "zustand";

interface SelectionStats {
  chars: number;
  words: number;
}

interface SelStatsStore {
  stats: SelectionStats | null;
  set: (s: SelectionStats | null) => void;
}

export const useSelectionStats = create<SelStatsStore>((set) => ({
  stats: null,
  set: (stats) => set({ stats }),
}));

export const selectionStatsReporter: Extension = EditorView.updateListener.of((update) => {
  if (!update.selectionSet && !update.focusChanged && !update.docChanged) return;
  const sel = update.state.selection.main;
  if (sel.empty || !update.view.hasFocus) {
    if (useSelectionStats.getState().stats) useSelectionStats.getState().set(null);
    return;
  }
  const text = update.state.sliceDoc(sel.from, sel.to);
  useSelectionStats.getState().set({
    chars: text.length,
    words: text.trim() ? text.trim().split(/\s+/).length : 0,
  });
});
